import PopoverTrigger from './PopoverTrigger'

export default PopoverTrigger
